export default __webpack_public_path__ + "static/media/dreamfest (3).fb2aca28.jpg";